import base from './map.options.base';

// the reason this is a function is because the google.xxx object may not be ready
// when this file is imported
export default () => ({
  ...base(),
  zoomControl: true,
  zoomControlOptions: {
    position: google.maps.ControlPosition.LEFT_BOTTOM
  }
});
